import React, { useMemo } from 'react';

import { ProgressBar, Button } from '../_shared';
import { Container } from './Program.styled';
import ArrowRight from '../../assets/icons/arrow-right';
import './Program.scss';

const PUBLIC_ENDORSEMENT = 'excel-for-real-estate';

const Program = ({
  id = 0,
  hasStarted,
  program,
  progress,
  locked = false,
  onSelect,
}) => {
  const percent = useMemo(() => {
    const totalPercent = program.courses.reduce((p, c) => {
      const userCourse = progress.find(
        ({ course: coourse }) => coourse && coourse._id === c._id
      );

      if (userCourse) {
        const total =
          userCourse.course.lessons.length + userCourse.course.quizzes.length;
        const current =
          userCourse.completedLessons.length +
          userCourse.completedQuizzes.length;
        return p + Math.min(100, (current / total) * 100);
      } else {
        return p;
      }
    }, 0);
    return Math.floor(parseFloat(totalPercent) / program.courses.length);
  }, [program, progress]);

  const handleUnlock = () => {
    window.open(
      'https://www.adventuresincre.com/accelerator/endorsements/',
      '_blank'
    );
  };

  return (
    <Container
      className="flex flex-col w-full h-full bg-white relative"
      key={program.id}
      onClick={
        locked && program.id !== PUBLIC_ENDORSEMENT
          ? handleUnlock
          : onSelect(program.id)
      }
    >
      {locked && program.id !== PUBLIC_ENDORSEMENT && (
        <div className="overlay">
          <Button
            type="misc"
            className={`unlock-btn m-auto mt-5 border-solid rounded-lg text-white bg-transparent border-white`}
            caption="Upgrade To Unlock Endorsement"
            onClick={handleUnlock}
          />
        </div>
      )}
      <div className="img-wrapper">
        <img className="w-full" src={program.image} alt={program.title} />
      </div>
      <div className="text-primary flex flex-col p-5 flex-grow sm:p-4">
        <div className="program-title">{program.title}</div>
        <div className="text-black flex-grow w-full program-description">
          {program.description.replace('[OPTIONAL] ', '')}
        </div>
        {!locked || program.id === PUBLIC_ENDORSEMENT ? (
          <>
            <div className="mt-4 w-full">
              <ProgressBar height={4} value={hasStarted ? percent : 0} />
            </div>
            {hasStarted ? (
              <Button
                type="misc"
                className={`continue-btn m-auto mt-5 border-solid rounded-lg text-light-yellow bg-transparent border-light-yellow`}
                caption={
                  <>
                    Continue <ArrowRight className="ml-2" />
                  </>
                }
                onClick={onSelect(program.id)}
              />
            ) : (
              <div className="flex justify-end w-full">
                {/* <Button
                  type="flat"
                  className={`learn-more py-3 mt-5 border border-solid text-black bg-transparent border-white text-xl`}
                  caption="Learn More"
                /> */}
                <Button
                  type="flat"
                  className={`start-btn py-3 mt-5 border border-solid text-light-yellow bg-transparent border-white`}
                  caption="Start Endorsement"
                  onClick={onSelect(program.id)}
                />
              </div>
            )}
          </>
        ) : (
          <>
            <div className="mt-4 w-full">
              <ProgressBar height={4} value={0} />
            </div>
            <div className="flex justify-between w-full">
              <Button
                type="flat"
                className={`learn-more py-3 mt-5 border border-solid text-black bg-transparent border-white text-xl`}
                caption="Learn More"
                onClick={handleUnlock}
              />
              <Button
                type="flat"
                className={`start-btn py-3 mt-5 border border-solid text-light-yellow bg-transparent border-white`}
                caption="Upgrade To Unlock"
                icon="lock"
                onClick={handleUnlock}
              />
            </div>
          </>
        )}
      </div>
    </Container>
  );
};

export default Program;
